import { IRecipientProfileHlaInfo } from '@nkr/models/index';

interface IState {
    data: IRecipientProfileHlaInfo,
    hash: string,
    showModal: boolean,
}

const initialState: IState = {
    data: undefined,
    hash: '',
    showModal: false,
};

const hlaReducer = (state: IState, action: { type: string, value: any }): IState => {
    if (action.type == 'afterLoad') {
        return {
            ...state,
            data: action.value.data,
            hash: action.value.hash,
        };
    }

    if (action.type == 'updateHash') {
        return { ...state, hash: action.value };
    }

    if (action.type == 'updateData') {
        return { ...state, data: action.value };
    }

    if (action.type == 'toggleModal') {
        return { ...state, showModal: action.value };
    }

    return { ...state };
};

export {
    IState, initialState,
    hlaReducer
};